module.exports = __webpack_public_path__ + "media/images/icon/ranking/first-a1d5228f164e477ef39e597117c07e58.png";